export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img4-7a3480710dbb270875db4a3ff88d796a.jpg";